(() => {
    const controllerKey = '__brandFeaturedCollectionsController';
    if (window[controllerKey]) return;

    const renderedTemplates = new WeakMap();
    const renderedStates = new WeakMap();
    let animationFrameScheduled = false;

    const getSectionWrapper = (slot) => {
        const sectionId = slot.dataset.brandFeaturedSectionId;
        return (
            (sectionId && document.getElementById(`shopify-section-${sectionId}`)) ||
            slot.closest('[id^="shopify-section-"]')
        );
    };

    const setSlotVisibility = (slot, visible) => {
        const wrapper = getSectionWrapper(slot);
        if (!wrapper) return;

        wrapper.hidden = !visible;
        if (visible) {
            wrapper.setAttribute('data-brand-featured-visible', '');
        } else {
            wrapper.removeAttribute('data-brand-featured-visible');
        }
    };

    const markRevealItemsReady = (root) => {
        root.querySelectorAll('.reveal-item').forEach((element) => {
            element.classList.add('reveal-ready');
        });
    };

    const initializeInsertedContent = (output) => {
        if (typeof onReveal === 'function') {
            Promise.resolve(onReveal([output]))
                .then(() => {
                    if (typeof updateItemZIndex === 'function') {
                        return updateItemZIndex([output]);
                    }
                })
                .catch(() => markRevealItemsReady(output));
        } else {
            markRevealItemsReady(output);
        }

        if (typeof _initPreloadImg === 'function') {
            Promise.resolve(_initPreloadImg()).catch(() => {});
        }
    };

    const renderSlot = (slot, index) => {
        const output = slot.querySelector('[data-brand-featured-output]');
        if (!output) return;

        const candidates = slot.querySelectorAll(
            'template[data-brand-featured-candidate]'
        );
        const candidate = Array.from(candidates).find(
            (template) =>
                Number(template.dataset.brandFeaturedIndex) === index
        );

        if (candidate) {
            if (
                renderedStates.get(slot) === 'collection' &&
                renderedTemplates.get(slot) === candidate
            ) {
                setSlotVisibility(slot, true);
                return;
            }

            const content = document.importNode(candidate.content, true);
            output.replaceChildren();
            setSlotVisibility(slot, true);
            output.appendChild(content);
            renderedTemplates.set(slot, candidate);
            renderedStates.set(slot, 'collection');
            initializeInsertedContent(output);
            return;
        }

        if (slot.dataset.brandFeaturedEditor === 'true') {
            const emptyState = slot.querySelector(
                'template[data-brand-featured-empty]'
            );

            if (
                renderedStates.get(slot) === 'empty' &&
                renderedTemplates.get(slot) === emptyState
            ) {
                setSlotVisibility(slot, true);
                return;
            }

            output.replaceChildren();
            setSlotVisibility(slot, true);
            if (emptyState) {
                output.appendChild(document.importNode(emptyState.content, true));
            }
            renderedTemplates.set(slot, emptyState);
            renderedStates.set(slot, 'empty');
            return;
        }

        if (renderedStates.get(slot) !== 'hidden') {
            output.replaceChildren();
            renderedTemplates.set(slot, null);
            renderedStates.set(slot, 'hidden');
        }
        setSlotVisibility(slot, false);
    };

    const renderAll = () => {
        const mainContent = document.getElementById('MainContent');
        if (!mainContent) return;

        mainContent
            .querySelectorAll('[data-brand-featured-slot]')
            .forEach((slot, index) => renderSlot(slot, index));
    };

    const scheduleRender = () => {
        if (animationFrameScheduled) return;

        animationFrameScheduled = true;
        window.requestAnimationFrame(() => {
            animationFrameScheduled = false;
            renderAll();
        });
    };

    window[controllerKey] = { render: scheduleRender };
    document.addEventListener('shopify:section:load', scheduleRender);
    document.addEventListener('shopify:section:unload', scheduleRender);
    document.addEventListener('shopify:section:reorder', scheduleRender);

    renderAll();
})();
